
import { Component } from '@angular/core';
import { L10nService } from '@jct/localization';

@Component({
  selector: 'contact.page',
  templateUrl: './contact-page.html',
})
export class ContactPage { 
  constructor(
      public l10n: L10nService)
    { }
    
  sections = {
    en: {
      title: 'English Speaking International program',
      phone: '02-6751011',
      mail: 'esp@jct.ac.il'
    }
  };
}

